// @flow
import React from 'react';

import {
  Button,
} from 'chronos-components';

import * as S from './styled';

type Props = {
  /** selected item */
  selected?: string,
  /** Function that is called when the item clicked. */
  onClick?: { (type: string): void },
};

const ViewControls = ({
  selected,
  onClick,
}: Props) => (
  <S.ViewControls>
    <Button
      isSelected={selected === 'calendar'}
      onClick={() => onClick('calendar')}
    >
      Calendar
    </Button>
    <Button
      isSelected={selected === 'timeline'}
      onClick={() => onClick('timeline')}
    >
      Timeline
    </Button>
  </S.ViewControls>
);

ViewControls.defaultProps = {
  selected: null,
  onClick: () => {},
};

export default ViewControls;
